export const TypeChart: import('../../../sim/dex-data').ModdedTypeDataTable = {
	ground: {
		inherit: true,
		damageTaken: {
			sandstorm: 3,
			deserteddunes: 3,
			Bug: 0,
			Dark: 0,
			Dragon: 0,
			Electric: 3,
			Fairy: 0,
			Fighting: 0,
			Fire: 0,
			Flying: 0,
			Ghost: 0,
			Grass: 1,
			Ground: 0,
			Ice: 1,
			Normal: 0,
			Poison: 2,
			Psychic: 0,
			Rock: 2,
			Steel: 0,
			Stellar: 0,
			Water: 1,
		},
	},
	rock: {
		inherit: true,
		damageTaken: {
			sandstorm: 3,
			deserteddunes: 3,
			Bug: 0,
			Dark: 0,
			Dragon: 0,
			Electric: 0,
			Fairy: 0,
			Fighting: 1,
			Fire: 2,
			Flying: 2,
			Ghost: 0,
			Grass: 1,
			Ground: 1,
			Ice: 0,
			Normal: 2,
			Poison: 2,
			Psychic: 0,
			Rock: 0,
			Steel: 1,
			Stellar: 0,
			Water: 1,
		},
	},
	steel: {
		inherit: true,
		damageTaken: {
			psn: 3,
			tox: 3,
			sandstorm: 3,
			deserteddunes: 3,
			Bug: 2,
			Dark: 0,
			Dragon: 2,
			Electric: 0,
			Fairy: 2,
			Fighting: 1,
			Fire: 1,
			Flying: 2,
			Ghost: 0,
			Grass: 2,
			Ground: 1,
			Ice: 2,
			Normal: 2,
			Poison: 3,
			Psychic: 2,
			Rock: 2,
			Steel: 2,
			Stellar: 0,
			Water: 0,
		},
	},
};
